import { PropsWithChildren } from 'react';
import ReactModal from 'react-modal';

interface Props extends PropsWithChildren {
  isOpen: boolean;
  onRequestClose: (e: React.MouseEvent | React.KeyboardEvent) => void;
}

export default function Modal(props: Props): JSX.Element {
  return (
    <ReactModal
      isOpen={props.isOpen}
      shouldCloseOnOverlayClick={true}
      className="tw-h-fit tw-w-fit tw-relative tw-top-1/2 tw--translate-y-1/2 tw-p-6 tw-bg-white tw-mx-auto tw-rounded-md"
      overlayClassName="tw-bg-black/50 tw-h-screen tw-fixed tw-w-screen tw-top-0 tw-z-20"
      onRequestClose={props.onRequestClose}
    >
      {props.children}
    </ReactModal>
  );
}
